import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FrequentAccessCardData } from './frequent-access-card.types';

@Component({
  selector: 'common-frequent-access-card',
  templateUrl: './frequent-access-card.component.html',
  styleUrls: ['./frequent-access-card.component.scss'],
})
export class FrequentAccessCardComponent {
  @Input() data: FrequentAccessCardData = {
    title: 'Frequent access',
    accessType: 'Provider',
    dateText: 'Mon - Fri',
  };

  @Output() action = new EventEmitter<void>();

  onAction(): void {
    this.action.emit();
  }
}
